import { render, staticRenderFns } from "./SupportPanel.vue?vue&type=template&id=204b40ca"
import script from "./SupportPanel.vue?vue&type=script&lang=ts"
export * from "./SupportPanel.vue?vue&type=script&lang=ts"
import style0 from "./SupportPanel.vue?vue&type=style&index=0&id=204b40ca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports